
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltyBonusTypeAddForm from '@/form/loyalty/loyaltyBonusType/LoyaltyBonusTypeAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltyBonusTypeAddComponent extends Vue {
    @Prop() readonly form!: LoyaltyBonusTypeAddForm;
}
